<ng-template #template>
  <ng-container *ngIf="model.visible">
    <ng-template [component]="{ name: model.componentName, data: { model: model.componentData } }"></ng-template>
  </ng-container>
</ng-template>